export default "__VITE_ASSET__DsAgg5gf__"